// utils/duTrack.ts

// 可根据业务改 key 名
const DU_BROWSER_ID_STORAGE_KEY = 'du_browser_id';

let duSessionIdPromise: Promise<string> | null = null;
let duBrowserIdPromise: Promise<string> | null = null;

interface DuConf {
  du_api_key: string;
  du_business_id: string;
  url?: string;
}

declare global {
  interface Window {
    du_web_sdk: any;
  }
}

export function getDuSessionId(conf: DuConf): Promise<string> {
  const url = conf.url || window.location.href;

  if (!window.du_web_sdk) return Promise.resolve('');
  if (duSessionIdPromise) return duSessionIdPromise;

  duSessionIdPromise = new Promise((resolve) => {
    try {
      window.du_web_sdk!.getSessionID(conf.du_api_key, conf.du_business_id, url, function (sessionID: string) {
        resolve(sessionID || '');
      });
    } catch (e) {
      resolve('');
    }
  });

  return duSessionIdPromise;
}

export function getDuBrowserId(conf: DuConf): Promise<string> {
  if (!window.du_web_sdk) return Promise.resolve('');
  if (duBrowserIdPromise) return duBrowserIdPromise;

  duBrowserIdPromise = new Promise((resolve) => {
    try {
      // 先尝试从本地缓存读取
      let cached = '';
      try {
        cached = window.localStorage ? window.localStorage.getItem(DU_BROWSER_ID_STORAGE_KEY) || '' : '';
      } catch (e) {
        cached = '';
      }

      if (cached) {
        resolve(cached);
        return;
      }

      // 本地无缓存，再调用 SDK 获取
      window.du_web_sdk!.getBrowserID(conf.du_api_key, conf.du_business_id, 'maimai.cn', function (browserID: string) {
        const id = browserID || '';
        // 写入本地缓存，后续复用
        if (id) {
          try {
            window.localStorage && window.localStorage.setItem(DU_BROWSER_ID_STORAGE_KEY, id);
          } catch (e) {
            // 忽略存储异常（隐身模式 / 禁用存储等）
          }
        }
        resolve(id);
      });
    } catch (e) {
      resolve('');
    }
  });

  return duBrowserIdPromise;
}
